import { Skeleton } from '@/components/atoms/Skeleton';
import { breakpointDesktopDefault } from '@/hooks/useBreakpoint';

export default function PaginaPublicacaoTemplateFallback() {
  return (
    <div>
      <Skeleton style={{ height: 32 }} />
      <div
        style={{
          ...breakpointDesktopDefault,
          width: '100%',
          minHeight: '60vh',
        }}
      >
        <Skeleton style={{ height: '100vh' }} />
      </div>
    </div>
  );
}
